
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/animation-and-game-development",
      function () {
        return require("private-next-pages/school/animation-and-game-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/animation-and-game-development"])
      });
    }
  